import { JobApplicationType } from '../domain/types';

export const jobApplicationTypeLabels: Record<JobApplicationType, string> = {
  SALES: 'Sales',
  GENERIC: 'Generica',
};
